<template>
    <div class="bgfff mt20">
        <el-empty :description="description"></el-empty>
    </div>
</template>
<script>
export default {
  name: "empty",
  props: {
      description:{
        type: String,
        default: '暂无数据'
      }
  },


};
</script>